import * as Yup from 'yup';
import {
  validEmail,
  validPassword,
  validateName,
  alphanumericPattern,
} from '@/utils/forms/schemas';
import { useI18n } from 'vue-i18n';

export const useSchemas = () => {
  const { t } = useI18n();

  /**
   * Schema SignUp
   */
  const schemaSignUpEmail = Yup.object({
    email: Yup.string()
      .email(t('rules.email'))
      .matches(validEmail, t('rules.email'))
      .required(t('rules.required')),
    acceptTerms: Yup.bool().required(t('rules.required')).isTrue(t('rules.required')),
  });

  /**
   * Change Email
   */
  const schemaChangeEmail = Yup.object({
    email: Yup.string()
      .email(t('rules.email'))
      .matches(validEmail, t('rules.email'))
      .required(t('rules.required')),
  });

  /**
   * Recovery Email
   */
  const schemaRecoveryEmail = Yup.object({
    email: Yup.string()
      .email(t('rules.email'))
      .matches(validEmail, t('rules.email'))
      .required(t('rules.required')),
  });

  /**
   * Change Email Code
   */
  const schemaChangeEmailCode = Yup.object({
    code: Yup.string().required(t('rules.required')),
  });

  /**
   * Change Password
   */
  const schemaChangePassword = Yup.object({
    newPassword: Yup.string()
      .required(t('rules.required'))
      .matches(validPassword, t('rules.password')),
    confirmPassword: Yup.string()
      .required(t('rules.required'))
      .matches(validPassword, t('rules.password'))
      .oneOf([Yup.ref('newPassword'), ''], t('rules.passwordMismatch')),
  });

  /**
   * Signup Password
   */
  const schemaSignUpPassword = Yup.object({
    password: Yup.string()
      .required(t('rules.required'))
      .matches(validPassword, t('rules.password')),
  });

  /**
   * Reset Password
   */
  const schemaResetPassword = Yup.object({
    password: Yup.string()
      .required(t('rules.required'))
      .matches(validPassword, t('rules.password')),
  });

  /**
   * Personaliza City
   */
  const schemaPersonalizeCity = Yup.object({
    city: Yup.string().required(t('rules.required')),
  });

  /**
   * Personalize Dates
   */
  const schemaPersonalizeDates = Yup.object({
    arrival: Yup.date().required(t('rules.required')),
    departure: Yup.date().required(t('rules.required')),
  });
  /**
   * Personalize Info
   */
  const schemaPersonalizeInfo = Yup.object({
    name: Yup.string().required(t('rules.required')),
    lastname: Yup.string().required(t('rules.required')),
    location: Yup.string().required(t('rules.required')),
    birthdate: Yup.date().required(t('rules.required')),
  });

  /**
   * Setting Edit
   */
  const schemaSettingEdit = Yup.object({
    language: Yup.string().required(t('rules.required')),
  });

  /**
   * Supervisor register
   */
  const schemaEvaluatorForm = Yup.object({
    name: Yup.string().required(t('rules.required')),
    lastName: Yup.string().required(t('rules.required')),
    email: Yup.string()
      .email(t('rules.email'))
      .matches(validEmail, t('rules.email'))
      .required(t('rules.required')),
    prefixPhone: Yup.string().required(t('rules.required')),
    phoneNumber: Yup.number().required(t('rules.phoneInvalid')),
  });

  const schemaProfileEdit = Yup.object({
    name: Yup.string().matches(validateName, t('rules.names')).required(t('rules.required')),
    lastName: Yup.string().matches(validateName, t('rules.names')).required(t('rules.required')),
    genre: Yup.string().required(t('rules.required')),
    nationality: Yup.string().required(t('rules.required')),
    prefixPhone: Yup.string().required(t('rules.required')),
    phoneNumber: Yup.string()
      .matches(/^[A-Za-z0-9]+$/, t('rules.phoneInvalid'))
      .required(t('rules.number'))
      .min(6, t('rules.phoneMin'))
      .max(10, t('rules.phoneMax')),
    birthdate: Yup.date().required(t('rules.required')),
    documentId: Yup.string()
      .matches(alphanumericPattern, t('rules.documentId'))
      .required(t('rules.required')),
  });

  return {
    schemaProfileEdit,
    schemaSignUpEmail,
    schemaChangeEmail,
    schemaRecoveryEmail,
    schemaChangeEmailCode,
    schemaChangePassword,
    schemaSignUpPassword,
    schemaResetPassword,
    schemaPersonalizeCity,
    schemaPersonalizeDates,
    schemaPersonalizeInfo,
    schemaSettingEdit,
    schemaEvaluatorForm,
  };
};
